<div class="container">
  @if (!storeId) {
    <div class="instructions">
      <pdq-heading element="h6">Before you connect</pdq-heading>
      <p class="body-14-regular">Make sure these are in place first:</p>
      <ul class="steps body-14-regular">
        <li>
          The Order Protection app is installed on your Shopify store
          @if (storeDomain) {
            <span>
              (<strong>{{ storeDomain }}</strong
              >)</span
            >
          }
          .
        </li>
        <li>You have access to your Order Protection dashboard, where you'll approve PDQ's access request.</li>
      </ul>
      <p class="body-14-regular">
        Then click <strong>Connect</strong> at the top of the page and we'll guide you through the rest.
      </p>
    </div>
  } @else {
    <pdq-heading element="h6">Order Protection Store ID</pdq-heading>
    <div class="general">
      <pdq-input [value]="storeId" [readonly]="true" type="text" [clipboard]="true"></pdq-input>
      @if (storeDomain) {
        <p class="hint body-12-regular">
          Linked to <strong>{{ storeDomain }}</strong
          >.
        </p>
      }
    </div>

    @if (applicationId) {
      <pdq-heading element="h6">Partner Application ID</pdq-heading>
      <div class="general">
        <pdq-input [value]="applicationId" [readonly]="true" type="text" [clipboard]="true"></pdq-input>
      </div>
    }
  }
</div>
